import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dk-field-validation-error-message',
    templateUrl: './dk-field-validation-error-message.component.html',
    styleUrl: './dk-field-validation-error-message.component.scss',
    standalone: false
})
export class DkFieldValidationErrorMessageComponent {
  @Input() control: AbstractControl; // form['formCountrolName']
  @Input() patternRequired = false;
  @Input() patternMessage = '';

  constructor(private translateService: TranslateService) {}

  get controlError() {
    if (this.control?.invalid && this.control?.touched) {
      if (this.patternRequired && this.patternMessage) {
        return this.patternMessage;
      } else if (this.control?.errors) {
        if (this.control.errors['required']) {
          return this.translateService.instant('general.warning-required-field');
        }
        if (this.control.errors['email']) {
          return this.translateService.instant('user-add.email-not-correct');
        }
        if (this.control.errors['minlength']) {
          return `${this.translateService.instant('user-add.min-length')}: ${this.control.errors['minlength'].requiredLength}`;
        }
        if (this.control.errors['phoneAlreadyExist']) {
          return this.translateService.instant('user-add.already-in-use-phone');
        }
        if (this.control.errors['emailAlreadyExist']) {
          return this.translateService.instant('user-add.already-use-mail');
        }
        if (this.control.errors['emailWrongFormat']) {
          return this.translateService.instant('user-add.already-in-use-phone');
        }
        if (this.control.errors['missMatchedConfirmPassword']) {
          return this.translateService.instant('change-password.password-match');
        }
      }
    }
    return null;
  }
}
